module.exports = __webpack_public_path__ + "1ab66e92817de961bdac2e7bff7c5b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/proposal-1-no-words.png
// module id = 1073
// module chunks = 0